import { render, staticRenderFns } from "./ErrorSubmitForm6.vue?vue&type=template&id=4e36ea82&scoped=true"
import script from "./ErrorSubmitForm6.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitForm6.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36ea82",
  null
  
)

export default component.exports